
export default function ImportantNotice() {
  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-b-2 border-amber-300 py-6 px-6 shadow-sm">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-full flex-shrink-0 shadow-md">
            <i className="ri-information-line text-white text-2xl"></i>
          </div>
          <div>
            <p className="text-lg md:text-xl text-amber-900 leading-relaxed">
              <strong className="font-bold text-amber-950">Ważne:</strong> Zamknięcie Beach Club Laurel – z powodów konserwacji od 13 kwietnia do 30 czerwca Beach Club Laurel pozostanie zamknięty. Przepraszamy za możliwe niedogodności.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
